import { PilotSearchQuery } from '../methods/search';
import { fetchSearchExportOptions } from '../methods/searchV3';

type ExportOptionsParams = {
  query: PilotSearchQuery;
};

export const getSearchExportOptions = async ({
  query,
}: ExportOptionsParams) => {
  const response = await fetchSearchExportOptions(query);
  return response.data.attributes;
};
